import React, { useState,useEffect,useRef } from "react";
import format from "date-fns/format";
import { connect } from "react-redux";
import { withRouter } from "react-router"
import { useHistory } from "react-router-dom";
import * as actions from "../../../../store/actions";
import { VALIDATE_TEMPLATE } from "../../../../store/actions/actionTypes";

import TemplateIcon from "../../../../components/uiElements/icons/onboardingIcons/TemplateIcon";
import { NO_DATA_FOUND } from "../../../../constants";
import EditTemplate from "./EditTemplate";
import SearchBox from "../../../../components/formElements/searchbox/SearchBox";
import CreateNotes from "./CreateNotes";
import { useInfiniteScroll } from "../../../../utils/pagination";


const TemplateList = ({
  match,
  templates,
  setEditMode,
  searchValue,
  editMode,
  form,
  validateData,
  addTemplatesNote,
  getAllPatientNotes,
  currentData,
  setCurrentNoteData,
  clearCurrentNoteData,
  deleteScreenshot,
  addNote,
  editTemplateById,
  searchTemplates,
  getAllTemplates,
  total_pages,
  setValue,
  setComp,
  setVal,
}) => {
  const fetchedTemplates = templates;
  const id = match?.params?.id 
  const [ids,setId]=useState(0);
  const [modal,setShowModal]=useState(false);
  const [modals,setShowModals]=useState(false);
  const [page, setPage] = useState(1);
  const ploader = useRef(null);
  useInfiniteScroll(ploader, () => {
    setPage(page => page + 1);
  }); 
  useEffect(() => {
    if (page > 0 && page <= total_pages && !searchValue) {
      getAllTemplates("", page);
    } else if (
      searchValue &&
      searchValue.length >= 3 &&
      page > 0 &&
      page <= total_pages
    ) {
      getAllTemplates(searchValue, page);
    }
    // eslint-disable-next-line
  }, [page, searchValue]);

  return (
    <>
    {modal && (
        <EditTemplate
          isOpen={modal}
          closeModal={() => {
            setShowModal(false);
            setEditMode(false);
            setValue(true)
            setVal(true)
            setComp(false)
            getAllPatientNotes(id, "", page)
          }}
          editMode={editMode}
          setEditMode={setEditMode}
          setValue={setValue}
          setComp={setComp}
          setVal={setVal}
          form={form}
          validateData={validateData}
          editTemplateById={editTemplateById}
          getAllPatientNotes={getAllPatientNotes}
          pid={ids}
          currentData={currentData}
          setCurrentNoteData={setCurrentNoteData}
          clearCurrentNoteData={clearCurrentNoteData}
          deleteScreenshot={deleteScreenshot}
          setShowModal={setShowModal}
        />
      )}
      {modals && (
        <CreateNotes
          isOpen={modals}
          closeModal={() => {
            setShowModals(false);
            setEditMode(false);
          }}
          editMode={editMode}
          setEditMode={setEditMode}
          setValue={setValue}
          setVal={setVal}
          setComp={setComp}
          form={form}
          validateData={validateData}
          addNote={addNote}
          addTemplatesNote={addTemplatesNote}
          getAllPatientNotes={getAllPatientNotes}
          pid={id}
          currentData={currentData}
          setCurrentNoteData={setCurrentNoteData}
          clearCurrentNoteData={clearCurrentNoteData}
          deleteScreenshot={deleteScreenshot}
          setShowModal={setShowModal}
        />)}
         <div className="row m-3">
        <div className="col-md-5 mt-2 noteSearch">
        <SearchBox
            value={searchValue}
            onChange={val => {
              searchTemplates({
                searchValue: val,
                total_pages: 1,
              });
              setPage(1);
            }}
          />
        </div>
        <div className="ml-auto px-3">
        <button
            className="patient-add-prescriptions"
            onClick={() => {
              setShowModals(true);
              setEditMode(true)
            }}
            
          >
          Create New
          </button>
        </div>
      </div>
         {fetchedTemplates?.length === 0 ? (
        <p className="content-center m-auto not-found-image">
          <img
            src={NO_DATA_FOUND}
            width={366}
            height={300}
            alt="requests-not-found"
          />
        </p>
      ) : (
        
        
        <div className="note-templates mb-0 m-3 ">
          <table class="table mt-2 mb-5">
            <thead>
              <tr>
                <th>Choose template</th>
                <th>Date Created</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {fetchedTemplates &&
                fetchedTemplates.map((x, i) => {
                  return (
                    <tr
                      key={i}
                      onClick={() =>{
                        setShowModal(true)
                              setEditMode(true);
                              setId(x.id)
                      }}
                    >
                      <td>{x?.note_name?.replace(/&nbsp;/g, " ")}</td>
                      <td>
                        {format(new Date(x?.created_at), "MMMM dd, yyyy")}
                      </td>
                      <td
                        onClick={e => {
                          e.stopPropagation();
                        }}
                        style={{ "text-align": "right" }}
                      >
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

const mapStoreToProps = ({ dashboard, validation }) => ({
  template: dashboard.templates.currentData,
  form: validation.data,
  editMode: dashboard.templates.editMode,
  templates: dashboard.templates.all,
  searchData: dashboard.templates.search,
  searchValue: dashboard.templates.searchValue,
  form: validation.data,
  total_pages: dashboard.templates.total_pages,
});

const mapDispatchToProps = dispatch => ({
  validateData: template =>
    dispatch(actions.validateData(VALIDATE_TEMPLATE, template)),
  getTemplateById: id => dispatch(actions.getTemplateById(id)),
  setTemplateData: Data => dispatch(actions.setTemplateData(Data)),
  clearTemplateData: () => dispatch(actions.clearTemplateData()),
  editTemplateById: (id, cb) => dispatch(actions.editTemplateById(id, cb)),
  setEditMode: () => dispatch(actions.setEditMode()),
  clearEditMode: () => dispatch(actions.clearEditMode()),
  deleteTemplateById: (tempID, cb) =>
    dispatch(actions.deleteTemplateById(tempID, cb)),
  searchTemplates: q => dispatch(actions.templateSearch(q)),
  getAllTemplates: (q, page) => dispatch(actions.getAllTemlates(q, page)),
  setCurrentNoteImages: payload =>
    dispatch(actions.setCurrentNoteImages(payload)),
  setCurrentNoteData: payload => dispatch(actions.setCurrentNoteData(payload)),
  clearCurrentNoteData: () => dispatch(actions.clearCurrentNoteData()),
  deleteScreenshot: url => dispatch(actions.deleteScreenshot(url)),
  addNote: (cd,pid) =>
    dispatch(actions.addNote(cd,pid)),
    addTemplatesNote: (cd,pid) =>
    dispatch(actions.addTemplatesNote(cd,pid)),
  getAllTemplates: (q, page) => dispatch(actions.getAllTemlates(q, page)),
  setEditMode: () => dispatch(actions.setEditMode()),
  emptyTemplateData: () => dispatch(actions.emptyTemplateData()),
  searchTemplates: q => dispatch(actions.templateSearch(q)),
  getAllPatientNotes: (id, q, page) =>
  dispatch(actions.getAllPatientNotes(id, q, page)),

});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(TemplateList)
);

